<template>
    <div class="shops" ref="shops" v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" style="-webkit-user-drag: none;">
        <p-header title="搜尋"/>
        <div class="search">
            <div class="input">
                <img src="@/assets/img/search.svg">
                <input type="search" ref="input" v-model="keywords" @input="input" @change="change">
                <img class="delete" src="@/assets/img/delete.svg" @click="cancel">
            </div>
            <div class="history" v-show="searching">
                <div class="item" v-for="history in histories" :key="history.id" @click="setKeywords(history.keywords)">
                    <img src="@/assets/img/search-green.svg">
                    <span>{{ history.keywords }}</span>
                </div>
            </div>
        </div>
        <div class="count" :class="{gray: !page.total}" v-show="! searching">
            “ {{ page.total }}筆搜尋結果 ”
        </div>
        <div class="miss-msg" v-if="page.total == 0 && ! searching">
            Sorry ,<br/>
            未搜尋到您想要的結果
        </div>
        <div class="list container" v-show="!searching">
            <div class="content">
                <shop-item v-for="shop in shops" :key="shop.id" :shop="shop" :location="location"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '../components/Header';
    import ShopItem from './Item';
    import * as apis from "../../apis";
    import * as R from "ramda";

    export default {
        name: 'ShopSearch',
        components: {
            'p-header': Header,
            'shop-item': ShopItem,
        },
        data() {
            return {
                shops: [],
                loading: false,
                page: {
                    total: 0,
                    current_page: 0,
                    last_page: 0,
                },
                location: {
                    alias: '',
                    city: '',
                    district: '',
                    road: '',
                    name: '',
                    phone: '',
                    additional: '',
                    latitude: null,
                    longitude: null,
                },
                keywords: '',
                searching: true,
                histories: [],
            }
        },
        computed: {
            canNotLoadMore() {
                return !(this.page.total && this.page.current_page < this.page.last_page && !this.loading);
            },
        },
        methods: {
            getNearbyShops() {
                this.loading = true;
                apis.getNearbyShops({
                    latitude: this.location.latitude,
                    longitude: this.location.longitude,
                    keywords: this.keywords,
                    sort: 'distance',
                    category_id: 0,
                }).then(res => {
                    this.shops = res.data.data;
                    this.page = res.data.meta;
                    this.loading = false;
                });
            },
            loadMore() {
                this.loading = true;

                apis.getNearbyShops({
                    latitude: this.location.latitude,
                    longitude: this.location.longitude,
                    keywords: this.keywords,
                    sort: 'distance',
                    category_id: 0,
                    page: this.page.current_page + 1,
                }).then(res => {
                    this.shops = R.concat(this.shops, res.data.data);
                    this.page = res.data.meta;
                    this.loading = false;
                });
            },
            input() {
                apis.searchHistories(this.keywords).then(res => {
                    this.histories = res.data;
                })
            },
            change() {
                this.getNearbyShops();
                this.$refs.input.blur();
                this.searching = false;
            },
            cancel() {
                this.searching = true;
                this.keywords = '';
                this.input();
                this.shops = [];
                this.page = {
                    total: 0,
                    current_page: 0,
                    last_page: 0,
                };
                this.loading = false;
            },
            setKeywords(keywords) {
                this.keywords = keywords;
                this.getNearbyShops();
                this.searching = false;
            }
        },
        created() {
            this.location = JSON.parse(decodeURIComponent(this.$route.query.location));
        },
        mounted() {
            this.searching = true;
            this.$refs.input.focus();
            this.input();
        },
        activated() {
            if (! this.keywords) {
                this.searching = true;
                this.$refs.input.focus();
                this.input();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .shops {
        min-height: var(--app-height);
    }

    .search {
        margin: 10px 15px;

        .input {
            display: flex;
            border-radius: 20px 5px 5px 20px;
            background-color: #339933;
            box-shadow: 0 1px 5px 0 rgba(51,153,51,0.35);
            padding: 10px 15px 10px 10px;

            input {
                flex: 1;
                margin: 0 10px;
                border: none;
                background: transparent;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                color: #FFFFFF;

                &::-webkit-search-cancel-button {
                    display: none;
                }
            }

            .delete {
                cursor: pointer;
            }
        }
    }

    .history {
        .item {
            display: flex;
            align-items: center;
            padding: 10px;
            border-bottom: 1px solid rgba(51,153,51,0.1);
            cursor: pointer;

            span {
                margin: 0 10px;
                color: #000000;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
            }
        }
    }

    .count {
        color: #339933;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 20px;

        &.gray {
            color: #9B9B9B;
        }
    }

    .miss-msg {
        margin-top: 96px;
        color: #000000;
        font-size: 20px;
        letter-spacing: 0;
        line-height: 28px;
        text-align: center;
    }

    .container {
        text-align: left;
        margin: 0 15px;

        &.opacity {
            filter: opacity(0.3);
        }

        .title {
            font-weight: 500;
            font-size: 20px;

            .subtitle {
                font-size: 14px;
                font-weight: normal;
                color: #9B9B9B;
                margin: 0 5px;
            }
        }

        .content {
            margin: 5px 0;
        }
    }

</style>
